<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";
import LanguageModel from "../../models/LanguageModel";

export default {
  extends: BaseType,
  name: QuestionType.Statement,
  methods: {
    onEnter() {
      this.dirty = true;

      this._onEnter();
    },

    isValid() {
      return true;
    }
  }
};
</script>
